<template>
  <div>
    <el-card>
      <div class="forms">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item label="名称">
            <el-select v-model="form.productId" filterable clearable>
              <el-option v-for="(item, index) in selectListData" :label="item.productName" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="searchData">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-popconfirm title="您确定要删除多条数据吗？" @confirm="deleteData">
              <el-button class="white" slot="reference">删除</el-button>
            </el-popconfirm>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBorderColor" @click="exportData">导入</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="addHomeData('dialogForm')">新增故障自查</el-button>
          </el-form-item>
        </el-form>

        <el-table ref="table" v-loading="loading" :data="tableData" border tooltip-effect="dark" style="width: 100%; margin-top: 20px" @selection-change="handleSelectionChange" max-height="650">
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column prop="categoryName" label="分类" min-width="140" align="center" />
          <el-table-column prop="productName" label="产品名称" min-width="80" align="center" />
          <el-table-column prop="faultCause" label="故障原因" min-width="120" align="center" />
          <el-table-column prop="possibleCause" label="可能原因" min-width="120" align="center" />
          <el-table-column prop="exclusionAdvice" label="排除建议" min-width="260" align="center" />
          <el-table-column prop="updatedTime" label="变更时间" min-width="120" align="center" />
          <el-table-column prop="updatedBy" label="变更人" min-width="120" align="center" />
          <el-table-column prop="remark" label="备注" show-overflow-tooltip min-width="260" align="center" />
          <el-table-column label="操作" min-width="100" align="center" fixed="right">
            <template #default="scope">
              <div class="operate">
                <div class="btn" @click="edit(scope.row)">编辑</div>
                <el-popconfirm title="您确认要删除该条数据吗？" @confirm="deleteOnly(scope.row)">
                  <div slot="reference" class="btn">删除</div>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageData.page" :page-sizes="[10,20, 40, 60, 80, 100]" :page-size="pageData.pageSize" layout="total, prev, pager, next,sizes" :total="total"> </el-pagination>
        </div>
      </div>
    </el-card>

    <el-dialog :title="`故障自查${title}`" :visible.sync="dialogVisible" width="780px" @close="cancelBtn('dialogForm')">
      <!-- <div class="title">首页新增展图</div> -->
      <div class="forms">
        <el-form :model="dialogForm" :rules="dialogRules" ref="dialogForm" label-width="160px" class="demo-dialogForm" label-position="left">
          <el-form-item label="分类" prop="categoryName">
            <el-select v-model="dialogForm.categoryId" @change="categorySelect" clearable>
              <el-option v-for="item in categorySelectListData" :label="item.categoryName" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称" >
            <el-select v-model="dialogForm.productId" clearable>
              <el-option v-for="item in selectListData" :label="item.productName" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="故障原因" prop="faultCause">
            <div style="display: flex">
              <el-input v-model="dialogForm.faultCause"></el-input>
              <div style="display: flex; align-items: center; margin-left: 5px" @click="addFaultCause">
                <img style="width: 22px; height: 22px; margin-right: 5px" src="@/assets/gzh/pc/add.png" alt="" />
                <span>新增可能原因</span>
              </div>
            </div>
          </el-form-item>

          <div style="display: flex; align-items: flex-start" v-for="(item, index) in possibleCausesList" :key="index">
            <div>
              <el-form-item label="可能原因" prop="possibleCause">
                <el-input v-model="possibleCausesList[index].possibleCause"></el-input>
              </el-form-item>
              <el-form-item label="排除建议">
                <el-input type="textarea" v-model="possibleCausesList[index].exclusionAdvice"></el-input>
              </el-form-item>
            </div>
            <div @click="deleteFaultCause(index)">
              <img style="width: 22px; height: 22px; margin-top: 3px; margin-left: 5px" src="@/assets/gzh/pc/reduce.png" alt="" />
            </div>
          </div>
          <div class="footerBtn">
            <el-button class="dialogWhite" @click="cancelBtn('dialogForm')">取 消</el-button>
            <el-button class="dialogBtnBackgory" @click="submitForm('dialogForm')">确 定</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <Export ref="exportDialog" :type="type" :downloadTitle="downloadTitle" :getSearchList="getSearchList"></Export>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
import Export from "../exportFile/export.vue";
export default {
  name: "faultCause",
  components: {
    Export
  },
  data() {
    return {
      form: {
        productId: ""
      },
      ids: [],
      title: "新增",
      selectListData: [],
      categorySelectListData: [],
      loading: false,
      pageData: {
        page: 1,
        pageSize: 10
      },

      total: 0,
      tableData: [],
      dialogVisible: false,
      dialogForm: {
        categoryId: "",
        productId: "",
        faultCause: ""
      },
      rowId: "",
      faultCauseId: "",
      categoryId:'',
      possibleCausesList: [],
      dialogRules: {
        categoryId: [{ required: true, message: "请选择分类", trigger: "change" }],
        // productId: [{ required: true, message: "请选择产品名称", trigger: "change" }],
        faultCause: [{ required: true, message: "请输入故障原因", trigger: "blur" }]
        // possibleCause: [{ required: true, message: "请输入可能原因", trigger: "blur" }]
      },
      type: "gzh_fault_cause",
      downloadTitle: "故障自查导入模板"
    };
  },
  mounted() {
    this.getSeleteDataList();

    this.getSearchList({ ...this.pageData,...this.form  });
  },
  methods: {
    // 获取 下拉 数据
    getSeleteDataList() {
      apis.getAllProduct().then(res => {
        if (res.code === 200) {
          this.selectListData = res.data;
        }
      });
      apis.productGetCategoryList().then(res => {
        if (res.code === 200) {
          this.categorySelectListData = res.data;
        }
      });
    },
    // table 选中
    handleSelectionChange(val) {
      this.ids = val.map(item => item.id);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 新增
    addHomeData(formName) {
      this.getSeleteDataList();
      this.possibleCausesList = [];
      const json = {
        exclusionAdvice: "",
        possibleCause: ""
      };
      this.possibleCausesList?.push(json);

      this.dialogVisible = true;
      this.title = "新增";
      this.dialogForm = {};
      this.$refs[formName]?.resetFields();
    },

    // 获取 table 数据
    getSearchList(json) {
      this.loading = true;
      apis.faultDataList(json).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false;
        }
      });
    },
    exportData() {
      this.$refs.exportDialog.dialogVisible = true;
    },
    // 搜索
    searchData() {
      const json = {
        ...this.pageData,
        ...this.form
      };
      this.getSearchList(json);
    },
    // 批量 删除
    deleteData() {
      if (this.ids.length) {
        apis.faultDeleteMap(this.ids).then(res => {
          if (res.code === 200) {
            this.getSearchList({ ...this.pageData });
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
      }
    },
    // 监听 分类 选择
    categorySelect(value) {
      const json = {
        categoryId: value,
        page: 1,
        pageSize: 200
      };
      apis.productList(json).then(res => {
        if (res.code === 200) {
          this.selectListData = res.data;
        }
      });
    },
    //  添加故障原因
    addFaultCause() {
      const json = {
        exclusionAdvice: "",
        possibleCause: ""
      };
      this.possibleCausesList?.push(json);
    },
    // 删除故障原因
    deleteFaultCause(index) {
      if (this.possibleCausesList.length > 1) {
        this.possibleCausesList.splice(index, 1);
      }
    },

    // 确认 添加
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        const causesArray = this.possibleCausesList.filter(item => {
          // ||!item.exclusionAdvice 排除建议
          if (!item.possibleCause) {
            return item;
          }
        });
        if (causesArray.length > 0) {
          return this.$message({
            message: "请输入可能原因或排除建议",
            type: "warning"
          });
        }
        if (valid) {
          const json = {
            ...this.dialogForm,
            possibleCausesList: this.possibleCausesList
          };
          if (this.rowId) {
            json.id = this.rowId;
            json.faultCauseId = this.faultCauseId;
          }
          const Func = this.rowId ? apis.faultEdit(json) : apis.faultAdd(json);
          Func.then(res => {
            if (res.code === 200) {
              //productId:this.form.productId
              this.getSearchList({ ...this.pageData });
              this.dialogVisible = false;
              console.log(this.rowId ,2555);
              this.$message({
                message: `${this.rowId ? "修改" : "新增"}成功`,
                type: "success"
              });
            }
          });
        }
      });
    },
    //dialog 取消按钮
    cancelBtn(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    // 编辑
    edit(row) {
      console.log(row.id);
      
      this.faultCauseId = row.faultCauseId;
      // this.categoryId=row.categoryId
      this.possibleCausesList = [];
      this.getSeleteDataList();
      apis.queryFaultData(row.id).then(res => {
        if (res.code === 200) {
          console.log('res.data.categoryId', res.data.categoryId);
          this.rowId = res.data.id;
          this.dialogForm = {
            categoryId: res.data.categoryId,
            faultCause: res.data.faultCause,
            productId: res.data.productId
          };
          const json = {
            possibleCause: res.data.possibleCause,
            exclusionAdvice: res.data.exclusionAdvice
          };
          this.possibleCausesList.push(json);
          this.dialogVisible = true;
          this.title = "编辑";
        }
      });
    },
    // 删除一条
    deleteOnly(row) {
      apis.faultDeleteMap([row.id]).then(res => {
        if (res.code === 200) {
          this.getSearchList({ ...this.pageData });
          this.$message({
            message: "删除成功",
            type: "success"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  margin: 20px;
}

::v-deep .el-dialog__title {
  display: flex;
  align-items: center;
  font-size: 29px;
  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 29px;
    background-color: #008754;
    margin-right: 10px;
  }
}
.forms {
  .el-button--mini {
    margin-right: 20px;
  }
  .btnBackgory {
    width: 181px;
    height: 54px;
    background-color: #008754;
    color: white;
  }
  .white {
    width: 181px;
    height: 54px;
  }
  .btnBorderColor {
    width: 181px;
    height: 54px;
    color: #008754;
    border-color: #008754;
  }

  ::v-deep .el-form {
    // display: flex;
    // justify-content: space-between;
    .left {
      .el-input--mini .el-input__inner {
        width: 295px;
      }
    }
    .footerBtn {
      text-align: right;
      .dialogWhite {
        width: 145px;
        height: 54px;
      }
      .dialogBtnBackgory {
        width: 145px;
        height: 54px;
        background-color: #008754;
        color: white;
      }
    }
  }
}
.pageContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.aHref {
  color: #5e92ff;
}
.operate {
  display: flex;
  justify-content: space-around;
  .btn {
    color: #729fff;
  }
}
::v-deep .el-dialog {
  .el-form {
    .el-input {
      width: 770px;
    }
    .el-textarea__inner {
      width: 770px;
    }
  }
}
</style>
